<template>
  <div class="status-change-query-reenter-signature-upload">
    <div class="body"
         v-loading="committing"
         element-loading-text="数据提交中，请稍等...">
      <FileUploader v-model="form.signatureLink"
                    v-bind="upload"></FileUploader>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交保存</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
import FileUploader from '../../../../../../../../../widgets/FileUploader'
export default {
  name: 'StatusChangeQueryReenterSignatureUpload',
  components: {
    FileUploader
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      upload: {
        uploadAction: '/workspace/manager/portal/upload/document',
        acceptTypes: ['.doc', '.docx', '.pdf'],
        maxSize: 100 * 1024 * 1024
      },
      form: {
        signatureLink: ''
      },
      committing: false
    }
  },
  methods: {
    handleApply () {
      if (!this.form.signatureLink) {
        this.$message.warning('请先完成文件上传')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/status/change/queryReenter/submitSignature',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .status-change-query-reenter-signature-upload {
    & > .body {
      padding: 15px;
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
